module.exports = __webpack_public_path__ + "static/media/user3.917e31d3.gif";